import { useEffect } from "react";
import { usePatchPortfolioBusinessLoansMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPortfolioBusinessLoansMutation";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { getBusinessLoansEditFormSchema } from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormSchema";
import { mapPortfolioToBusinessLoansForm } from "web_myplann/Portfolio/Forms/BusinessLoansForm/mapPortfolioToBusinessLoansForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditBusinessLoansFormArgs = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const useEditBusinessLoansForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: UseEditBusinessLoansFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } =
		usePatchPortfolioBusinessLoansMutation(portfolioId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getBusinessLoansEditFormSchema(t),
		defaultValues: mapPortfolioToBusinessLoansForm(portfolio),
		mutate: (portfolioFields, options) => mutate(portfolioFields, options),
		successToast: t(Resources.Portfolio.EditPortfolio.savedToast, {
			type: getPortfolioTitle(portfolio, t),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
